import { ZoneViewFrame } from './zoneViewFrame.js';
import { STR } from 'utils/str.js';

/**
 * View to paint the body of the home. It stores a reference to the super home
 * view, and to every zoneView and manages the swapping of zone hiding or
 * showing the zone.
 */
export var BodyViewFrame = Backbone.View.extend({

  initialize: function() {
    this.zViews = {};
    this.model.on("change:zone", this._zonesSwapping, this);
  },

  _zonesSwapping: function() {
    var oldZone = this.model.previous("zone");
    var newZone = this.model.get("zone");
    if (!STR.isBlank(oldZone) && !STR.isBlank(oldZone)) {
      this.zViews[oldZone].$el.hide();
    }
    if (!STR.isBlank(newZone) && !STR.isBlank(newZone)) {
      this.zViews[newZone].$el.show();
    }

    this.model.trigger("changed:zone", newZone);
  },

  render: function() {
    _.each(this.model.configuration.get("confignav").get("zones"), function(zone) {
      var zView = new ZoneViewFrame({
        id: "phx-zone-" + zone.id,
        model: this.model, // eslint-disable-line no-invalid-this
        zJSON: zone
      });
      this.zViews[zone.id] = zView; // eslint-disable-line no-invalid-this
      this.$el.append(zView.render().el); // eslint-disable-line no-invalid-this
    }, this);
    return this;
  }

});
